document.addEventListener('DOMContentLoaded', () => {
    // CMS-safe guard: exit if Projects module is not present on the page
    const projectsSectionEl = document.querySelector('.projects-section');
    if (!projectsSectionEl) return;

    const projectsSwiperContainerEl =
        projectsSectionEl.querySelector('.projects-home-swiper');
    if (!projectsSwiperContainerEl) return;

    // Swiper strictly requires `.swiper-wrapper`
    const projectsSwiperWrapperEl =
        projectsSwiperContainerEl.querySelector('.swiper-wrapper');
    if (!projectsSwiperWrapperEl) return;

    const originalProjectSlideEls = Array.from(
        projectsSwiperContainerEl.querySelectorAll('.swiper-slide')
    );
    if (originalProjectSlideEls.length === 0) return;

    const projectFiltersListEl =
        projectsSectionEl.querySelector('.filters ul');

    const projectFilterItemEls = Array.from(
        projectsSectionEl.querySelectorAll('.filters li')
    );

    const projectProgressBarLoadedEl =
        projectsSectionEl.querySelector('.projects-progress-bar .loaded');

    /**
     * Update the progress bar based on the current slide position
     */
    const updateProjectsProgressBar = (projectsSwiperInstance) => {
        if (!projectProgressBarLoadedEl) return;

        const totalSlides = projectsSwiperInstance.slides.length;

        if (totalSlides === 0) {
            projectProgressBarLoadedEl.style.width = '0%';
            return;
        }

        if (totalSlides <= 1) {
            projectProgressBarLoadedEl.style.width = '100%';
            return;
        }

        const activeSlideIndex = Math.min(
            Math.max(projectsSwiperInstance.activeIndex, 0),
            totalSlides - 1
        );

        const progressPercent =
            ((activeSlideIndex + 1) / totalSlides) * 100;

        projectProgressBarLoadedEl.style.width = `${progressPercent}%`;
    };


    /**
     * Mark the given filter item as active
     */
    const setActiveProjectFilter = (filterItemEl) => {
        if (!filterItemEl) return;

        projectFilterItemEls.forEach((el) =>
            el.classList.remove('active')
        );

        filterItemEl.classList.add('active');
    };

    const normalizeCategoryValue = (value) => {
        if (!value) return '';
        return value.trim().toLowerCase();
    };

    const parseSlideCategories = (slideEl) => {
        const rawCategories = slideEl.getAttribute('data-category');
        if (!rawCategories) return [];

        return rawCategories
            .split(',')
            .map((category) => normalizeCategoryValue(category))
            .filter(Boolean);
    };

    const originalSlidesData = originalProjectSlideEls.map((slideEl) => ({
        el: slideEl,
        categories: parseSlideCategories(slideEl),
    }));

    const getFilterKey = (filterItemEl) => {
        const dataFilter = filterItemEl.getAttribute('data-filter');
        if (dataFilter) return normalizeCategoryValue(dataFilter);

        return normalizeCategoryValue(filterItemEl.textContent);
    };

    const syncProjectInfoHeights = (swiperInstance) => {
        if (!swiperInstance || !swiperInstance.slides) return;

        const projectInfoEls = Array.from(swiperInstance.slides)
            .map((slideEl) => slideEl.querySelector('.project-info'))
            .filter(Boolean);

        if (projectInfoEls.length === 0) return;

        projectInfoEls.forEach((infoEl) => {
            infoEl.style.height = '';
        });

        const maxProjectInfoHeight = projectInfoEls.reduce(
            (maxHeight, infoEl) =>
                Math.max(maxHeight, infoEl.getBoundingClientRect().height),
            0
        );

        if (maxProjectInfoHeight === 0) return;

        projectInfoEls.forEach((infoEl) => {
            infoEl.style.height = `${maxProjectInfoHeight}px`;
        });
    };

    const scrollProjectFilterIntoView = (filterItemEl) => {
        if (!filterItemEl || !projectFiltersListEl) return;

        const filtersContainerEl = projectFiltersListEl.parentElement;
        if (!filtersContainerEl) return;

        const containerRect = filtersContainerEl.getBoundingClientRect();
        const itemRect = filterItemEl.getBoundingClientRect();
        const edgeOffset = 12;
        const rightRevealOffset = Math.min(
            Math.max(containerRect.width * 0.3, 60),
            140
        );

        let scrollDelta = 0;

        if (itemRect.left < containerRect.left + edgeOffset) {
            scrollDelta = itemRect.left - containerRect.left - edgeOffset;
        } else if (itemRect.right > containerRect.right - rightRevealOffset) {
            scrollDelta =
                itemRect.right - containerRect.right + rightRevealOffset;
        }

        if (scrollDelta === 0) return;

        filtersContainerEl.scrollBy({
            left: scrollDelta,
            behavior: 'smooth',
        });
    };

    const applyProjectsFilter = (filterKey, swiperInstance) => {
        const normalizedFilterKey = normalizeCategoryValue(filterKey);

        const matchingSlides =
            normalizedFilterKey === 'all' || !normalizedFilterKey
                ? originalSlidesData
                : originalSlidesData.filter(({ categories }) =>
                      categories.includes(normalizedFilterKey)
                  );

        swiperInstance.removeAllSlides();

        if (matchingSlides.length > 0) {
            swiperInstance.appendSlide(matchingSlides.map(({ el }) => el));
        }

        swiperInstance.update();
        swiperInstance.slideTo(0, 0);
        updateProjectsProgressBar(swiperInstance);
        requestAnimationFrame(() => {
            syncProjectInfoHeights(swiperInstance);
            swiperInstance.update();
        });
    };

    // Ensure Swiper library is available
    if (typeof Swiper === 'undefined') return;

    /**
     * Initialize Projects Swiper
     * - full width slides
     * - no arrows
     * - no pagination bullets
     */
    const projectsHomeSwiper = new Swiper(
        projectsSwiperContainerEl,
        {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,

            watchOverflow: true,
            observer: true,
            observeParents: true,

            on: {
                init(swiper) {
                    syncProjectInfoHeights(swiper);
                    updateProjectsProgressBar(swiper);
                },

                slideChange(swiper) {
                    updateProjectsProgressBar(swiper);
                },

                resize(swiper) {
                    syncProjectInfoHeights(swiper);
                    updateProjectsProgressBar(swiper);
                },
            },
        }
    );

    // Force initial progress state
    updateProjectsProgressBar(projectsHomeSwiper);
    requestAnimationFrame(() => {
        syncProjectInfoHeights(projectsHomeSwiper);
        projectsHomeSwiper.update();
    });

    window.addEventListener('load', () => {
        syncProjectInfoHeights(projectsHomeSwiper);
        projectsHomeSwiper.update();
    });

    const initialFilterItemEl =
        projectsSectionEl.querySelector('.filters li.active');

    if (initialFilterItemEl) {
        applyProjectsFilter(
            getFilterKey(initialFilterItemEl),
            projectsHomeSwiper
        );
    }

    /**
     * Handle filter click → navigate to matching slide
     */
    if (projectFiltersListEl) {
        projectFiltersListEl.addEventListener('click', (event) => {
            const clickedFilterItemEl =
                event.target.closest('li');

            if (
                !clickedFilterItemEl ||
                !projectFiltersListEl.contains(clickedFilterItemEl)
            ) {
                return;
            }

            // Prevent `#` jump
            const anchorEl = event.target.closest('a');
            if (anchorEl) event.preventDefault();

            const filterKey = getFilterKey(clickedFilterItemEl);

            setActiveProjectFilter(clickedFilterItemEl);
            applyProjectsFilter(filterKey, projectsHomeSwiper);

            requestAnimationFrame(() => {
                scrollProjectFilterIntoView(clickedFilterItemEl);
            });
        });
    }
});



// WEBPACK FOOTER //
// ./resources/js/modules/projects-home-swiper.js